import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnInit,
  Output,
  EventEmitter,
  input,
  Signal,
  computed,
  inject,
} from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { BookingHeaderSummary } from '@fcom/common/interfaces';
import { MediaQueryService } from '@fcom/common/services';
import { TripType } from '@fcom/core/interfaces';
import { SelectorType } from '@fcom/booking-widget/interfaces/booking-widget.interface';
import { BUS_CONNECTION_LOCATION_CODES, RAIL_AND_FLY_LOCATION_CODES } from '@fcom/core/constants';

@Component({
  selector: 'fin-booking-header-summary',
  templateUrl: './booking-header-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BookingHeaderSummaryComponent implements OnInit {
  private mediaQueryService = inject(MediaQueryService);

  readonly TripType = TripType;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly SelectorType = SelectorType;

  isMobile$: Observable<boolean>;

  bookingSummary = input<BookingHeaderSummary>();
  @Input() isClickable = false;
  @Output() modifySearch: EventEmitter<SelectorType> = new EventEmitter();

  tripTypeIcon: Signal<SvgLibraryIcon> = computed(() => {
    return this.getTripTypeIcon(this.bookingSummary());
  });

  ngOnInit(): void {
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');
  }

  openBookingWidget(type: SelectorType): void {
    this.modifySearch.emit(type);
  }

  getTripTypeIcon(bookingSummary: BookingHeaderSummary): SvgLibraryIcon {
    const containsBusOrTrain = bookingSummary.locations.some((locationPair) => {
      return (
        BUS_CONNECTION_LOCATION_CODES.includes(locationPair.originLocationCode) ||
        BUS_CONNECTION_LOCATION_CODES.includes(locationPair.destinationLocationCode) ||
        RAIL_AND_FLY_LOCATION_CODES.includes(locationPair.originLocationCode) ||
        RAIL_AND_FLY_LOCATION_CODES.includes(locationPair.destinationLocationCode)
      );
    });

    if (containsBusOrTrain) {
      return SvgLibraryIcon.MINUS;
    }

    if (bookingSummary.tripType === TripType.RETURN) {
      return SvgLibraryIcon.RETURN_TRIP;
    }

    return SvgLibraryIcon.AIRCRAFT_HORIZONTAL;
  }
}
